import {fetchAllListPages} from '../service/listPagination'
import React, { useState, useEffect, useRef } from 'react'
import { Card, CardBody, CardHeader } from '../../_metronic/_partials/controls'
import {
  sortCaret,
  headerSortingClasses
} from '../../_metronic/_helpers'
import CoreCustomTable from './component/CoreCustomTable'
import { ClearFiltersButton, FilterSelect, PageSizeSelect, SearchField } from './component/TableFilters'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import Pagination from '@material-ui/lab/Pagination'
import { useSubheader } from '../../_metronic/layout'
import axios from 'axios'
import moment from 'moment'
import { baseURLV1 } from '../service/API.js'
import { Modal, TextField } from '@material-ui/core'
import { useSelector } from 'react-redux'
import * as XLSX from 'xlsx'
import Swal from "sweetalert2"
import Pagination2 from "@material-ui/lab/Pagination"
import "./style.css"
import { roleCheck } from '../service/role'
import { hasAction } from '../service/permissions'
import { apiMessage } from '../service/apiError'
import { useHistory } from "react-router-dom"

// Names what to change, because the operator's next move is a different date
// range or a cleared search box.
const REPORT_EMPTY = 'ไม่พบข้อมูลในช่วงวันที่และคำค้นที่เลือก ลองขยายช่วงวันที่ หรือล้างคำค้นแล้วค้นหาอีกครั้ง'

export const Report = () => {
  const { user } = useSelector(state => state.auth)
  const suhbeader = useSubheader()

  const [reportData, setReportData] = useState([])
  const reportKeys = useRef([])
  const reportKeyField = useRef(null)
  const [listReport, setListReport] = useState([])
  const [col, setCol] = useState([])
  const [dataDetail, setDataDetail] = useState([])
  const [reportValue, setReportValue] = useState(0)
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [sizePerPage, setSizePerPage] = useState(10)
  const [_totalSize, setTotalSize] = useState(100)
  const [loading, setLoading] = useState(false)
  const [is_loading, setIs_Loading] = useState(false)
  const [openDetailModalTable, setOpenDetailModalTable] = useState(false)
  const [openDetailTableData, setOpenDetailTableData] = useState([])

  const [page3, setPage3] = useState(1)
  const [totalPage3, setTotalPage3] = useState(1)
  const [limit3, setLimit3] = useState(10)
  const [_totalSize3, setTotalSize3] = useState(100)
  const [dataDetailIndex, setDataDetailIndex] = useState(null)
  const [placeholder, setPlaceholder] = useState("Text Search")
  const [search, setSearch] = useState("")
  const [search3, setSearch3] = useState("")

  const d = new Date()
  d.setDate(d.getDate() - 30)
  const [dateFrom, setDateFrom] = useState(moment(d).format('YYYY-MM-DD'))
  const [dateTo, setDateTo] = useState(moment(new Date()).format('YYYY-MM-DD'))
  
  const [canExport, setCanExport] = useState(false)
  const [canViewPii, setCanViewPii] = useState(false)
  
  suhbeader.setTitle('Report')

  const history = useHistory()

  useEffect(() => {
    localStorage.removeItem("ReportData2")
    localStorage.removeItem("keyField")
    checkAuth()
    // eslint-disable-next-line react-hooks/exhaustive-deps, no-use-before-define
  }, [])

  const checkAuth = async () => {
    try {
      const [data, pii] = await Promise.all([roleCheck('REPORT'), roleCheck('REPORT_PII')])
      setCanViewPii(pii.includes('VIEW'))
      setCanExport(hasAction(data, 'EXPORT'))
      
      if (!hasAction(data, 'VIEW')) {
        history.push('/auth/login')
        return
      }
      
      getListReport()
    } catch {
      history.push('/auth/login')
    }
  }
  const getListReport = () => {
    setIs_Loading(true)
    const apiUrls = `${baseURLV1}/dashboard/report?page=1&limit=100`
    fetchAllListPages(apiUrls, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${user.data.access_token}`
      }
    })
      .then(res => {
        setListReport(res.data.data || [])
        setIs_Loading(false)
      })
      .catch(err => {
        console.error('Error fetching report list:', err)
        setIs_Loading(false)
        Swal.fire(
          "โหลดรายการรายงานไม่สำเร็จ",
          apiMessage(err, "กรุณาลองใหม่อีกครั้ง"),
          "error"
        )
      })
  }


  const buildColumns = (data, displayColumnWidth, keyField) => {
    const keys = Object.keys(data[0])
    const array_width = displayColumnWidth ? displayColumnWidth.split(',') : []
    
    const newState = keys.map((item, key) => ({
      dataField: item,
      text: item,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (col) => (
        <span style={{ display: 'block', width: array_width[key] || 100 }}>
          {col}
        </span>
      ),
    }))

    if (keyField) {
      reportKeyField.current = keyField
      newState.push({
        text: "",
        dataField: "id",
        formatter: (id, row, rowIndex) => (
          <div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => detailItem({ row, rowIndex })}
            >
              Detail
            </button>
          </div>
        ),
      })
    }

    return newState
  }

  const bindReport = (id, _page, _sizePerPage, searchParam) => {
    if (!id) return
    
    const data = {
      report_id: id,
      date_from: moment(dateFrom).format('YYYY-MM-DD'),
      date_to: moment(dateTo).format('YYYY-MM-DD')
    }
    
    const searchQuery = searchParam && searchParam.trim() !== "" 
      ? `&search=${encodeURIComponent(searchParam.trim())}` 
      : ""
    
    const apiUrls = `${baseURLV1}/dashboard/report/render/${data.report_id}?page=${_page}&limit=${_sizePerPage}&dateFrom=${data.date_from}&dateTo=${data.date_to}${searchQuery}`
    
    setIs_Loading(true)
    axios({
      method: 'get',
      url: apiUrls,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${user.data.access_token}`
      }
    })
      .then(res => {
        if (res.data.data && res.data.data.length > 0) {
          const newState = buildColumns(
            res.data.data,
            res.data.displayColumnWidth,
            res.data.keyField
          )

          const totalpage = Math.ceil(res.data.total / res.data.limit)
          setTotalPage(totalpage)
          setTotalSize(res.data.total)
          setCol(newState)
          setReportData(res.data.data)
          reportKeys.current = res.data.dataKeyField || []
          reportKeyField.current = res.data.keyField || null
          setPlaceholder(res.data.filteredPlaceHolder || "Text Search")
          setIs_Loading(false)
        } else {
          setReportData([])
          setTotalPage(1)
          setTotalSize(0)
          setIs_Loading(false)
        }
      })
      .catch(err => {
        console.error('Error fetching report:', err)
        setReportData([])
        setTotalSize(0)
        setIs_Loading(false)
        Swal.fire("ดึงรายงานไม่สำเร็จ", apiMessage(err, "กรุณาลองใหม่อีกครั้ง"), "error")
      })
  }

  const changeReportDateFrom = (_dateFrom) => {
    setDateFrom(_dateFrom)
    setPage(1)
    if (reportValue) {
      bindReport(reportValue, 1, sizePerPage, search)
    }
  }

  const changeReportDateTo = (_dateTo) => {
    setDateTo(_dateTo)
    setPage(1)
    if (reportValue) {
      bindReport(reportValue, 1, sizePerPage, search)
    }
  }

  const handleSearch3 = () => {
    setPage3(1)
    setLimit3(10)
    detailSet(reportValue, 1, 10, search3)
  }


  const handleSearch = () => {
    if (!reportValue) {
      return Swal.fire("", "กรุณาเลือกรายงานที่ต้องการดู", "warning")
    }

    if (!dateFrom) {
      return Swal.fire("", "กรุณาเลือกวันที่เริ่มต้น", "warning")
    }

    if (!dateTo) {
      return Swal.fire("", "กรุณาเลือกวันที่สิ้นสุด", "warning")
    }

    setReportData([])
    setPage(1)
    bindReport(reportValue, 1, sizePerPage, search)
  }


  const handlePageChange = (event, value) => {
    setPage(value)
    setIs_Loading(true)
    bindReport(reportValue, value, sizePerPage, search)
  }

  const handlePageSizeChange = event => {
    setSizePerPage(event.target.value)
    setPage(1)
    setIs_Loading(true)
    bindReport(reportValue, 1, event.target.value, search)
  }

  const detailItem = (data) => {
    setOpenDetailTableData([])
    setDataDetail([])
    setDataDetailIndex(data)
    setPage3(1)
    setLimit3(10)
    
    try {
      const get = reportKeys.current
      const getkeyField = reportKeyField.current
      
      if (!get || !getkeyField) {
        Swal.fire("เปิดรายละเอียดไม่ได้", "กรุณาค้นหารายงานใหม่แล้วลองอีกครั้ง", "error")
        return
      }

      const cover_cam = get
      const id_item = cover_cam.find((datas, key) => data.rowIndex === key)

      if (!id_item) {
        Swal.fire("เปิดรายละเอียดไม่ได้", "ไม่พบแถวที่เลือก กรุณาค้นหารายงานใหม่", "error")
        return
      }

      const searchQuery = search3 && search3.trim() !== "" 
        ? `&search=${encodeURIComponent(search3.trim())}` 
        : ""
      
      const apiUrls = `${baseURLV1}/dashboard/report/renderDetail/${reportValue}?page=${page3}&limit=${limit3}&dateFrom=${dateFrom}&dateTo=${dateTo}&${encodeURIComponent(getkeyField)}=${encodeURIComponent(id_item[getkeyField])}${searchQuery}`
      
      axios({
        method: 'get',
        url: apiUrls,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${user.data.access_token}`
        }
      })
        .then(res => {
          if (res.data.data && res.data.data.length > 0) {
            const keys = Object.keys(res.data.data[0])
            const newState = keys.map(key => ({
              dataField: key,
              text: key,
              sort: true,
              sortCaret: sortCaret,
              headerSortingClasses
            }))
            
            setOpenDetailTableData(newState)
            setDataDetail(res.data.data)
            setOpenDetailModalTable(true)

            const totalpage = Math.ceil(res.data.total / res.data.limit)
            setTotalPage3(totalpage)
            setTotalSize3(res.data.total)
          } else {
            setOpenDetailModalTable(true)
            setDataDetail([])
            setOpenDetailTableData([])
          }
        })
        .catch(err => {
          console.error('Error fetching detail:', err)
          Swal.fire("โหลดรายละเอียดไม่สำเร็จ", apiMessage(err, "กรุณาลองใหม่อีกครั้ง"), "error")
        })
    } catch (error) {
      console.error('Error in detailItem:', error)
      Swal.fire("เปิดรายละเอียดไม่ได้", "ข้อมูลรายงานไม่ถูกต้อง กรุณาค้นหาใหม่", "error")
    }
  }

  const detailSet = (reportValue, page3Param, limit3Param, search3Param) => {
    if (!dataDetailIndex) return
    
    try {
      const get = reportKeys.current
      const getkeyField = reportKeyField.current
      
      if (!get || !getkeyField) {
        Swal.fire("เปิดรายละเอียดไม่ได้", "กรุณาค้นหารายงานใหม่แล้วลองอีกครั้ง", "error")
        return
      }

      const cover_cam = get
      const id_item = cover_cam.find((datas, key) => dataDetailIndex.rowIndex === key)

      if (!id_item) {
        Swal.fire("เปิดรายละเอียดไม่ได้", "ไม่พบแถวที่เลือก กรุณาค้นหารายงานใหม่", "error")
        return
      }

      const searchQuery = search3Param && search3Param.trim() !== "" 
        ? `&search=${encodeURIComponent(search3Param.trim())}` 
        : ""
      
      const apiUrls = `${baseURLV1}/dashboard/report/renderDetail/${reportValue}?page=${page3Param}&limit=${limit3Param}&dateFrom=${dateFrom}&dateTo=${dateTo}&${encodeURIComponent(getkeyField)}=${encodeURIComponent(id_item[getkeyField])}${searchQuery}`
      
      axios({
        method: 'get',
        url: apiUrls,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${user.data.access_token}`
        }
      })
        .then(res => {
          if (res.data.data && res.data.data.length > 0) {
            const keys = Object.keys(res.data.data[0])
            const _newState = keys.map(key => ({
              dataField: key,
              text: key,
              sort: true,
              sortCaret: sortCaret,
              headerSortingClasses
            }))
            
            setDataDetail(res.data.data)
            const totalpage = Math.ceil(res.data.total / res.data.limit)
            setTotalPage3(totalpage)
            setTotalSize3(res.data.total)
          } else {
            setDataDetail([])
            setTotalPage3(1)
            setTotalSize3(0)
          }
        })
        .catch(err => {
          console.error('Error fetching detail:', err)
          Swal.fire("โหลดรายละเอียดไม่สำเร็จ", apiMessage(err, "กรุณาลองใหม่อีกครั้ง"), "error")
        })
    } catch (error) {
      console.error('Error in detailSet:', error)
      Swal.fire("เปิดรายละเอียดไม่ได้", "ข้อมูลรายงานไม่ถูกต้อง กรุณาค้นหาใหม่", "error")
    }
  }


  const handleClose = () => {
    setOpenDetailModalTable(false);
  };

  const handlePageChange3 = (event, value) => {
    setPage3(value)
    detailSet(reportValue, value, limit3, search3)
  }

  const handlePageSizeChange3 = (event) => {
    const newLimit = parseInt(event.target.value, 10)
    setLimit3(newLimit)
    setPage3(1)
    detailSet(reportValue, 1, newLimit, search3)
  }



  const exportExcel = () => {
    if (!canExport) return
    if (!reportValue) {
      return Swal.fire("", "กรุณาเลือกรายงานที่ต้องการดาวน์โหลด", "warning")
    }

    setLoading(true)
    const headers = col.map(c => c.dataField).filter(field => field !== "id")
    const rows = []

    const data = {
      report_id: reportValue,
      date_from: moment(dateFrom).format('YYYY-MM-DD'),
      date_to: moment(dateTo).format('YYYY-MM-DD')
    }
    
    let apiUrls = `${baseURLV1}/dashboard/report/render/${data.report_id}?export=1&page=1&limit=1000000&dateFrom=${data.date_from}&dateTo=${data.date_to}`
    if (search && search.trim() !== '') {
      apiUrls += `&search=${encodeURIComponent(search.trim())}`
    }
    
    axios({
      method: 'get',
      url: apiUrls,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${user.data.access_token}`
      }
    })
      .then(res => {
        if (!res.data.data || res.data.data.length === 0) {
          setLoading(false)
          return Swal.fire("", "ไม่มีข้อมูลในช่วงที่เลือก จึงยังไม่มีอะไรให้ดาวน์โหลด", "info")
        }

        const _data = res.data.data
        _data.forEach((item) => {
          try {
            if (item['created_at']) {
              item['created_at'] = moment(item['created_at']).format('YYYY-MM-DD HH:mm:ss')
            }
          } catch (err) {
            console.error('Error formatting date:', err)
          }

          const row = headers.map(header => item[header] || '')
          rows.push(row)
        })

        const report = listReport.find(d => Number(d.id) === Number(reportValue))
        if (!report) {
          setLoading(false)
          return Swal.fire("ดาวน์โหลดไม่สำเร็จ", "ไม่พบรายงานที่เลือก กรุณาเลือกใหม่", "error")
        }

        const datas = [headers, ...rows]
        const fileName = `export-axa-${report.title}.xlsx`
        const ws = XLSX.utils.aoa_to_sheet(datas)
        const wb = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
        XLSX.writeFile(wb, fileName)
        setLoading(false)
      })
      .catch(err => {
        console.error('Error exporting Excel:', err)
        setLoading(false)
        Swal.fire("ดาวน์โหลดไม่สำเร็จ", apiMessage(err, "กรุณาลองใหม่อีกครั้ง"), "error")
      })
  }

  const getNameReport = (id) => {
    try {
      return listReport.find(t => Number(t.id) === Number(id)).filteredPlaceHolder
    } catch (error) {
      return ""
    }
  }

  return (
    <Card>
      <CardHeader title="Report">
      </CardHeader>
      <CardBody>
        <div className="d-flex justify-content-between">

          <div className="mb-3">
            <FilterSelect
              width={305}
              value={reportValue}
              options={[
                { value: 0, label: 'Please Select ...', disabled: true },
                ...listReport.map((data) => ({ value: data.id, label: data.title })),
              ]}
              onChange={even => {
                setReportValue(even.target.value)
                setReportData([])
                setDataDetail([])
                setOpenDetailTableData([])
                reportKeys.current = []
                reportKeyField.current = null
                setPage(1)
                setSizePerPage(10)
                let pla = getNameReport(even.target.value)
                setPlaceholder(pla ? pla : "Text Search")
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between mt-1">
          <div>
            Search :
            {/* Was a borderless grey `<input>` carrying `label=" "`, an attribute
                React does not put on an input, sitting beside real MUI date
                fields. Uncontrolled too, so nothing could clear it. */}
            <span className="mr-2 ml-1" style={{ display: 'inline-block', width: 250 }}>
              <SearchField
                disabled={!canViewPii}
                placeholder={placeholder ? placeholder : "Text Search"}
                value={search}
                onChange={setSearch}
                onSearch={handleSearch}
              />
            </span>
            <span style={{ display: 'inline-block', width: 72 }}>
              <ClearFiltersButton show={Boolean(search)} onClear={() => setSearch("")} />
            </span>
          </div>

          <div>

            <TextField
              id="DateFrom"
              type="date"
              label="Date From"
              defaultValue={dateFrom}
              style={{
                height: '38px',
                width: '185px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name =>
                changeReportDateFrom(name.target.value)
              }
            />
            <TextField
              id="DateFrom"
              type="date"
              label="Date To"
              defaultValue={dateTo}
              style={{
                height: '38px',
                width: '185px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name =>
                changeReportDateTo(name.target.value)
              }
            />
            <button
              type="button"
              id="button"
              className="btn btn-primary mt-1 mb-3 ml-3"
              onClick={handleSearch}
            >
              Search
            </button>
          </div>
        </div>
        {is_loading && (
          <div className="row">
            <div style={{
              position: "fixed", 
              top: "50%", 
              left: "50%", 
              transform: "translate(-50%, -50%)"
            }}>
              <div className="spinner-grow text-primary spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-secondary spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-success spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-danger spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-warning spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-info spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-light spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="spinner-grow text-dark spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}

        {/* A report that matched nothing used to hide this whole block and pop an
            error modal, so the page went blank below the filters and the only
            explanation was an alert that said "Error". The block still needs the
            row guard — BootstrapTable throws "No visible columns detected" when a
            report returns no rows to derive columns from — so the empty result
            gets its own line, in place, right where the table would be. */}
        {Number(reportValue) !== 0 && !is_loading && reportData.length === 0 ? (
          <div className="text-center text-dark-65 py-10">{REPORT_EMPTY}</div>
        ) : null}

        {Number(reportValue) !== 0 && reportData.length > 0 ? (
          <>
            <ToolkitProvider keyField={reportValue} exportCSV>
              {props => (
                <div>
                  {loading === true ? (
                    <button
                      style={{ width: '150px' }}
                      className="btn btn-primary"
                      type="button"
                      disabled
                    >
                      <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </button>
                  ) : (
                    
                    <button
                      type="button"
                      id="button"
                      className={`btn btn-primary ${canExport ? '' : ' d-none'}`}
                      style={{ width: '150px' }}
                      onClick={exportExcel}
                      disabled={is_loading || loading}
                    >
                      Export Excel
                    </button>
                  )}

                  <CoreCustomTable
                    {...props.baseProps}
                    data={reportData}
                    columns={col}
                    loading={is_loading}
                    emptyText={REPORT_EMPTY}
                  />

                  <div className=" col-lg-12">
                    {totalPage > 1 ? (
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mt-3">
                            <PageSizeSelect
                              label="Items per Page:"
                              value={sizePerPage}
                              onChange={handlePageSizeChange}
                              disabled={is_loading}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6" style={{ display: "flex", justifyContent: "flex-end" }}>
                          <Pagination
                            disabled={is_loading}
                            className="mt-3 "
                            count={totalPage}
                            page={page}
                            siblingCount={1}
                            boundaryCount={1}
                            variant="outlined"
                            shape="rounded"
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
            </ToolkitProvider>
          </>
        ) : (
          ''
        )}




        <Modal
          open={openDetailModalTable}
          disablePortal
          disableEnforceFocus
          disableAutoFocus
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="justify-content-center d-flex align-items-center mt-1">
                <span style={{ fontSize: "30px" }}></span>
              </div>
              <div className="modal-body my_scroll_divs">
                {openDetailTableData.length > 0 ? (
                  <>
                    <div className="row form-inline mb-2">
                      <div className="col-lg-4 col-md-4 col-sm-4">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Text Search"
                            disabled={!canViewPii}
                            style={{ width: "100%" }}
                            onChange={(e) => setSearch3(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2">
                        <div className="form-group">
                          <button
                            type="button"
                            id="button"
                            className="btn btn-primary"
                            style={{ width: "100%" }}
                            onClick={() => handleSearch3()}
                          >
                            Search
                    </button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <CoreCustomTable
                        data={dataDetail}
                        columns={openDetailTableData}
                        emptyText="ไม่มีรายละเอียดสำหรับรายการนี้"
                      />
                      <div className=" col-lg-12">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="mt-3">
                              <PageSizeSelect
                                label="Items per Page:"
                                value={limit3}
                                onChange={handlePageSizeChange3}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Pagination2
                              className="mt-3 "
                              count={totalPage3}
                              page={page3}
                              siblingCount={1}
                              boundaryCount={1}
                              variant="outlined"
                              shape="rounded"
                              onChange={handlePageChange3}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="text-center text-dark-65 py-10">
                    ไม่มีรายละเอียดสำหรับรายการนี้
                  </div>
                )}
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => handleClose()}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>



      </CardBody>
    </Card>
  )
}
